<template>
  <div class="sidebar">
    <div class="container">
      <div class="menu">
        <Hamburger
          @fontBig="$emit('fontBig')"
          @fontMiddle="$emit('fontMiddle')"
          @fontSmall="$emit('fontSmall')"
        />
        <div class="pic">
          <a href="#" title="logo">
            <img src="../../img/logo.png" alt="logo" />
          </a>
        </div>
        <h2>國人海外就業資源中心</h2>
      </div>
      <div class="choose_country">
        <button
          class="uk-button uk-button-default ukCountry"
          type="button"
          aria-label="下載專區"
          @click="$router.push('/download')"
        >
          <p class="text_title" :style="{ fontSize: fontSize.h5 + 'em' }">
            下載專區
          </p>
        </button>
        <!-- <button
          class="uk-button uk-button-default ukCountry"
          type="button"
          aria-label="得獎名單"
          @click="$router.push('/winner_list')"
        >
          <p class="text_title" :style="{ fontSize: fontSize.h5 + 'em' }">
            得獎名單
          </p>
        </button> -->
        <button
          class="uk-button uk-button-default ukCountry"
          type="button"
          aria-label="電子報訂閱"
          @click="$router.push('/news_subscription')"
        >
          <p class="text_title" :style="{ fontSize: fontSize.h5 + 'em' }">
            電子報訂閱
          </p>
        </button>
        <div class="country">
          <div class="uk-inline">
            <button
              class="uk-button uk-button-default ukCountry"
              type="button"
              aria-label="choose_country"
            >
              <div class="pic">
                <img src="../../img/nav3.svg" alt="選擇國家" />
              </div>
              <p class="text_title" :style="{ fontSize: fontSize.h5 + 'em' }">
                選擇國家
              </p>
              <span uk-icon="chevron-down"></span>
            </button>
            <div uk-dropdown="mode: click">
              <div class="area_group">
                <div
                  class="area"
                  v-for="coun in countryList"
                  :key="coun.nodeId"
                >
                  <p
                    :style="{ fontSize: fontSize.h5 + 'em' }"
                    class="area_title"
                  >
                    {{ coun.area }}
                  </p>
                  <div class="country">
                    <template
                      v-for="country in coun.countries"
                      :key="country.countryId"
                    >
                      <router-link
                        class="countryName"
                        :style="{ fontSize: fontSize.h5 + 'em' }"
                        :to="`/${country.countryId}`"
                        :title="country.countryName"
                      >
                        {{ country.countryName }}
                      </router-link>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-inline">
            <button
              class="uk-button uk-button-default"
              type="button"
              aria-label="海外就業指南"
            >
              <p class="text_title" :style="{ fontSize: fontSize.h5 + 'em' }">
                海外就業指南
              </p>
              <span uk-icon="chevron-down"></span>
            </button>
            <div uk-dropdown="mode: click" class="linkArea">
              <ul class="guide_wrap linkGroup">
                <li
                  class="guide_group"
                  v-for="message in guides"
                  :key="message.pageId"
                >
                  <a
                    class="guide_item"
                    :href="message.pageContent"
                    :title="'[另開新視窗]' + message.nodeName"
                    :style="{ fontSize: fontSize.p + 'em' }"
                    target="_blank"
                  >
                    <div class="pic">
                      <template
                        v-for="(image, index) in message.imageFiles"
                        :key="index"
                      >
                        <img :src="image.filePath" :alt="message.nodeName" />
                      </template>
                    </div>
                    <div class="txt">
                      <p :style="{ fontSize: fontSize.p + 'em' }">
                        {{ message.pageTitle }}
                      </p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="font_size">
          <a class="circle" @click="$emit('fontBig')" title="字體大小顯示大">
            <p href="#">大</p>
          </a>
          <a class="circle" @click="$emit('fontMiddle')" title="字體大小顯示中">
            <p href="#">中</p>
          </a>
          <a class="circle" @click="$emit('fontSmall')" title="字體大小顯示小">
            <p href="#">小</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, reactive } from "vue";
import Hamburger from "./Hamburger.vue";
import { apiCountry, apiGuide } from "@/api/api.js";

export default {
  name: "Sidebar",
  props: [],
  emits: ["fontBig"],
  components: {
    Hamburger,
  },
  setup() {
    let fontSize = inject("fontSize");
    const countryList = reactive([]);
    const guides = reactive([]);
    apiGuide()
      .then((res) => {
        res.data.forEach((i) => {
          guides.push(i);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    apiCountry()
      .then(function (res) {
        res.data.areas.forEach((i) => {
          countryList.push(i);
        });
      })
      .catch(function (res) {
        console.log(res);
      });
    return {
      fontSize,
      countryList,
      guides,
    };
  },
};
</script>

<style scoped lang="scss">
.text_title {
  font-size: 1.25em;
  color: $main_color;
  font-weight: 500;
}
.uk-button {
  padding: 0 15px;
}
.ukCountry {
  padding: 0 10px 0 15px;
}
.uk-button-default {
  @include flex_center();
  border: none;
  p {
    padding: 0;
  }
  .pic {
    width: 30%;
    padding-right: 10px;
  }
}

a {
  padding-right: 20px;
}
.area_group {
  padding: 15px;
}
.linkArea {
  width: 280px !important;
  .linkGroup {
    display: flex;
    flex-direction: column;
    a {
      padding: 5px 10px;
      font-size: $h5;
      &:hover {
        background-color: #fff;
      }
    }
  }
}

.uk-dropdown {
  right: 0 !important;
  top: 41px;
  width: 350px;
  .guide_group {
    border-bottom: 0.5px dashed #b2b2b1;
  }
  .guide_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .pic {
      width: 18%;
      margin-right: 8px;
      img {
        width: 100%;
      }
    }
    .txt {
      p {
        color: $sidebar_gray;
      }
    }
  }
}
.area {
  margin: 10px 2px;
  .area_title {
    font-size: 1.25em;
    margin: 0px 0px 5px 5px;
    text-align: left;
  }
  a {
    border: 1.5px solid $hr_gray;
    padding: 4px;
    margin: 3px;
    color: $sidebar_gray;
    font-weight: normal;
    &:hover {
      background-color: $main_color;
      color: $main_sec_color;
    }
  }
}

.sidebar {
  @include md {
    background-color: $main_color;
    border-bottom: 5px solid $main_sec_color;
  }
  .container {
    padding: 10px 70px;
    @include lg {
      padding: 15px 70px;
    }
    @include sm {
      padding: 10px 30px;
    }
    @include flex();
    justify-content: space-between;
    .menu {
      @include flex();
      h2,
      .uk-button-default {
        color: $main_color;
        @include md {
          color: #fff;
          font-size: $h2;
        }
      }
      .pic {
        display: none;
        @include md {
          display: inline-block;
          width: 12%;
          margin-right: 10px;
          a {
            padding-right: 0;
          }
        }
      }
    }
    .choose_country {
      @include flex();
      @include lg {
        display: none;
      }
      .country {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .font_size {
        @include flex();
        transition: 0.3s ease-in-out;
        .circle {
          &:hover {
            background-color: $main_color;
          }
          &:hover p {
            color: $main_sec_color;
          }
          margin-left: 10px;
          @include flex_center();
          flex-direction: column;
          height: 40px;
          width: 40px;
          border: 1px solid $main_color;
          border-radius: 50%;
        }
        p {
          text-align: center;
          display: inline-block;
          padding-left: 20px;
        }
      }
      @include flex();
    }
  }
}
</style>
